module.exports = __webpack_public_path__ + "static/logo-6b174b4e3265e37f0b55ef2975f60d5a.png";